
// Contact section configuration
export const contactConfig = {
  backgroundImage: 'https://raw.githubusercontent.com/stone1971grey/projekt-bilder/main/Hero_kontakt.jpg',
  overlayGradient: 'rgba(0, 0, 0, 0.1)', // Updated to even lighter overlay
  sectionHeight: '700px',
};
